import { render, staticRenderFns } from "./FooterLanding.vue?vue&type=template&id=f51680d8&scoped=true"
var script = {}
import style0 from "./FooterLanding.vue?vue&type=style&index=0&id=f51680d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51680d8",
  null
  
)

export default component.exports